
















import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { analysisStores } from '@/store/poultry/analysis';
import dayjs, { Dayjs} from 'dayjs';
import { ScoreAnalysis } from '@/models/poultry/analysis.model';
import { setFormattedDate } from '@/utils/date.formatter';

@Component({
  components: {}
})

export default class VaccinationAnalysisTableBody extends Vue {
  store = analysisStores.vaccination.list;

  get vaccinations() {
    return this.store.sortedVaccination;
  }

  getPublishedMonth(date: string) {
    return setFormattedDate(date);
  }
}
